import $ from "jquery";

const sellCarSelectModel = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            model: ".js-FormModelField",
        };

        if ($(el.model).length === 0) return;

        $(document).on("input", el.model, function (e) {
            e.preventDefault();
            const depends = $($(this).data("depend"));

            const isChecked = $(this).prop("checked");

            for (const i in depends) {
                const depend = depends[i];
                const selector = depend["for"];
                const options = depend["options"];

                const selectEl = $(selector);

                selectEl.empty();
                if (isChecked) {
                    options?.forEach((option) => {
                        selectEl.append(
                            $("<option></option>")
                                .attr("value", option.value)
                                .text(option.label),
                        );
                    });
                }
                selectEl.trigger("change");
            }
        });
    };

    init();
};

try {
    sellCarSelectModel();
} catch (error) {
    console.error("sellCarSelectModel", error);
}
